import React, { useMemo } from 'react';
import config from '../config/config';
import { FORTELLIS_BOT_HELLO_MESSAGE } from './constants';

function getAuthHeader(auth) {
  const { accessToken } = auth;
  if (accessToken) {
    return {
      Authorization: `Bearer ${accessToken}`
    };
  }
}

function getAnonymousURL(auth, url) {
  const { isAuthenticated } = auth;
  if (isAuthenticated) {
    return url;
  } else {
    return `${config.api.anonymousUrl}`;
  }
}

function safeParse(item) {
  try {
    return JSON.parse(item);
  } catch (err) {
    return undefined;
  }
}

function useLoggedInUser(auth, entity) {
  return useMemo(
    () => ({
      user: {
        userGuid: auth?.sub || '',
        loginId: auth?.userData?.email || '',
        firstName: auth?.userData?.name?.split(' ')[0] || '',
        helloMessage: FORTELLIS_BOT_HELLO_MESSAGE,
        orgId: entity?.id || '',
        userRole: null,
        orgName: entity?.name || ''
      },
      stores: []
    }),
    [
      auth?.sub,
      auth?.userData?.email,
      auth?.userData?.name,
      entity?.id,
      entity?.name
    ]
  );
}

export { getAuthHeader, getAnonymousURL, safeParse, useLoggedInUser };
